<div class="store-dropdown-container" [ngClass]="{ 'store-dropdown-display': isDisplayed }">
    <span class="store-dropdown-container-title">{{ title }}</span>
    <ng-container *ngLet="selectedStores | async as selectedStores">
        <span class="store-dropdown-container-text" *ngFor="let store of selectedStores | slice: 0 : 3">
            {{ getStoreName(store) }}
        </span>
        <span class="store-dropdown-container-text" *ngIf="selectedStores?.length > 3">
            +{{ selectedStores?.length - 3 }} {{ 'ORDER.STORES.MORE_STORES' | translate }}
        </span>
    </ng-container>
    <button
        fcp-button
        class="fcp-button-subtle"
        data-e2e-hook="edit-store"
        (click)="openStoresModal(chooseStoreModalId)"
    >
        {{ buttonTitle }}
    </button>
</div>
<fc-choose-stores-modal [modalId]="chooseStoreModalId"></fc-choose-stores-modal>
<fc-choose-single-store-modal modalId="select-one-store-modal"></fc-choose-single-store-modal>
<ng-container *fcMediaWrapper="'mobile'">
    <fc-backdrop *ngIf="isDisplayed" class="store-dropdown-backdrop"></fc-backdrop>
</ng-container>
<fc-choose-single-store-for-copying-modal
    [modalId]="getSelectStoreForCopyingModalId"
></fc-choose-single-store-for-copying-modal>
